// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  entryId: __t.string().name("entry_id"),
  npcId: __t.string().name("npc_id"),
  slotIndex: __t.i32().name("slot_index"),
  itemId: __t.string().name("item_id"),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  metadataJson: __t.string().name("metadata_json"),
});
